import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateFiservPaymentModuleForm, { type FormValues } from './UpdateFiservPaymentModuleForm';

type UpdateFiservPaymentModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdateFiservPaymentModuleDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: UpdateFiservPaymentModuleDrawerProps) => {
    const { t } = useTranslation(['fiservPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('fiservPaymentModuleDetails:paymentModuleDrawer.cancelButton')}
                    </Button>
                    <Button form="updateFiservPaymentModule" htmlType="submit" type="primary">
                        {t('fiservPaymentModuleDetails:paymentModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('fiservPaymentModuleDetails:paymentModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateFiservPaymentModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateFiservPaymentModuleDrawer;

export const useUpdateFiservPaymentModuleDrawer = (
    moduleId: string,
    initialValues: UpdateFiservPaymentModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdateFiservPaymentModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
